module.exports = __webpack_public_path__ + "static/media/excercies-image@3x.d98df5ba.png";